import { render } from "./project-model.html?vue&type=template&id=d656927c&scoped=true&ts=true"
import script from "./project-model.ts?vue&type=script&lang=ts"
export * from "./project-model.ts?vue&type=script&lang=ts"

import "./project-model.scss?vue&type=style&index=0&id=d656927c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d656927c"]])

export default __exports__